export let getUrlPaymentsNFTPay = [
/*     {address:'0X48D14B936A04675A546A81A26BEBB11FE7C9BDC7',urlPayments:'https://sandbox.nftpay.xyz/iframe/iframe_pay/5be3fad7-3ccf-4cfb-adf4-5b34d1016653?'},
 */
    {address: '0X41C1462A5BF15633F3C43FDC3FF9E57C2A93CFDB', urlPayments: 'https://sandbox-winter-checkout.onrender.com/?projectId=9356 '}
]